import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type BaseRouteDefinition = `${typeof baseRoute}/category/${number | ':categoryId'}/subCategory`;

type QueryRouteDefinition = `${typeof baseRoute}/category/${number | ':categoryId'}/subCategory?year=${string}`;

type RouteDefinition = BaseRouteDefinition | QueryRouteDefinition;

export const ROUTE: RouteDefinition = `${baseRoute}/category/:categoryId/subCategory`;

export const URL = (categoryId: number, year?: string): RouteDefinition => year
	? `${baseRoute}/category/${categoryId}/subCategory?year=${year}`
	: `${baseRoute}/category/${categoryId}/subCategory`;
